import { render, staticRenderFns } from "./PoiCardTitle.vue?vue&type=template&id=16f61e27&"
import script from "./PoiCardTitle.vue?vue&type=script&lang=ts&"
export * from "./PoiCardTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports